<script setup lang="ts">
  import { type HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  import { useModalContext } from '@gat-ship/vue-components'
  import { useGatDialogContext } from '@gat-ship/vue-components'
  import { useWizardContext } from '../wizards/wizard.vue'
  const modalContext = useModalContext()
  const gatDialogContext = useGatDialogContext()
  const wizardContext = useWizardContext()
  const props = defineProps<{
    class?: HTMLAttributes['class']
    /** If true, the padding will be applied. */
    show?: boolean
  }>()

  function shouldShow() {
    return (
      modalContext.modalType !== 'none' ||
      wizardContext.provided ||
      gatDialogContext.provided ||
      props.show
    )
  }
</script>
<template>
  <div
    v-if="shouldShow()"
    :class="
      cn(
        'flex flex-col gap-3',
        {
          'p-5':
            modalContext.modalType !== 'none' ||
            gatDialogContext.provided ||
            wizardContext.provided
        },
        props.class
      )
    "
  >
    <slot />
  </div>
  <template v-else>
    <slot />
  </template>
</template>
